
import Cell from 'vux/src/components/cell/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'


export default {
components: {
Cell,
XHeader,
Group,
XButton
},
props: ['id', 'name'],
data() {
return {

call: [],
priceList: []
}
},
mounted: function () {
document.title =  this.$props.name
this.$nextTick(function () {
this.$vux.loading.show('数据加载中')
this.$http.get(this.tianYiWebUrl + '/wechat/area/ajaxGetDetail', {params: {id: this.id}}).then(r => {
if (r.data.code === 200) {
this.call = r.data.data.call
this.priceList = r.data.data.priceList
this.currentAgentList= r.data.data.currentAgentList
console.log(this.priceList)
console.log(this.currentAgentList)
console.log(this.call)
}
});
this.$vux.loading.hide()
})
},
methods: {
doCall(no) {
window.location.href = 'tel://' + no;
},
}
};



// WEBPACK FOOTER //
// ./src/components/uc/JoinDetail.vue